import { render } from "./QuantitySelector.vue?vue&type=template&id=13e8aef5&scoped=true"
import script from "./QuantitySelector.vue?vue&type=script&lang=js"
export * from "./QuantitySelector.vue?vue&type=script&lang=js"

import "./QuantitySelector.vue?vue&type=style&index=0&id=13e8aef5&scoped=true&lang=scss"

import exportComponent from "/home/sergiugata/taptasty/-taptasty-order/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e8aef5"]])

export default __exports__